// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Code Context Menu */
.code-context-menu {
  background: var(--background-color);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-width: 280px;
  z-index: 1000;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 14px;
  overflow: hidden;
  animation: contextMenuFadeIn 0.2s ease-out;
}

[data-theme='dark'] .code-context-menu {
  background: var(--background-color);
  border-color: #555;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

@keyframes contextMenuFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Context Menu Header */
.context-menu-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  color: var(--text-color);
}

[data-theme='dark'] .context-menu-header {
  background: #2d3748;
  border-bottom-color: #555;
}

.context-menu-icon {
  margin-right: 8px;
  color: #007bff;
  font-size: 16px;
}

/* Context Menu Divider */
.context-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 4px 0;
}

[data-theme='dark'] .context-menu-divider {
  background: #555;
}

/* Context Menu Section */
.context-menu-section {
  padding: 4px 0;
}

.context-menu-label {
  padding: 8px 16px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

[data-theme='dark'] .context-menu-label {
  color: #adb5bd;
}

/* Context Menu Items */
.context-menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: var(--text-color);
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
  font-family: inherit;
}

.context-menu-item:hover {
  background: #f8f9fa;
}

[data-theme='dark'] .context-menu-item:hover {
  background: #2d3748;
}

.context-menu-item:active {
  background: #e9ecef;
}

[data-theme='dark'] .context-menu-item:active {
  background: #4a5568;
}

.context-menu-item-icon {
  margin-right: 12px;
  font-size: 16px;
  color: #6c757d;
  width: 16px;
  text-align: center;
}

[data-theme='dark'] .context-menu-item-icon {
  color: #adb5bd;
}

/* Specific icon colors */
.context-menu-item:hover .context-menu-item-icon {
  color: #007bff;
}

.context-menu-item[title*="R Console"] .context-menu-item-icon {
  color: #276dc3;
}

.context-menu-item[title*="RStudio"] .context-menu-item-icon {
  color: #75aadb;
}

.context-menu-item[title*="SAS"] .context-menu-item-icon {
  color: #e74c3c;
}

.context-menu-item[title*="Copy"] .context-menu-item-icon {
  color: #28a745;
}

.context-menu-item[title*="Download"] .context-menu-item-icon {
  color: #6c757d;
}

[data-theme='dark'] .context-menu-item[title*="Download"] .context-menu-item-icon {
  color: #adb5bd;
}

/* Context Menu Info */
.context-menu-info {
  padding: 8px 16px;
  color: #6c757d;
  font-size: 12px;
  text-align: center;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
}

[data-theme='dark'] .context-menu-info {
  color: #adb5bd;
  border-top-color: #555;
  background: #2d3748;
}

/* Code Block Styling for Right-Click */
.code-block-interactive {
  position: relative;
  cursor: context-menu;
  -webkit-user-select: text;
          user-select: text;
}

.code-block-interactive:hover {
  background: rgba(0, 123, 255, 0.05);
  border-radius: 4px;
}

[data-theme='dark'] .code-block-interactive:hover {
  background: rgba(74, 144, 226, 0.1);
}

.code-block-interactive::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.code-block-interactive:hover::after {
  box-shadow: inset 0 0 0 1px rgba(0, 123, 255, 0.2);
}

[data-theme='dark'] .code-block-interactive:hover::after {
  box-shadow: inset 0 0 0 1px rgba(74, 144, 226, 0.3);
}

/* Notification Styling */
.code-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #28a745;
  color: white;
  padding: 12px 20px;
  border-radius: 4px;
  z-index: 10000;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: notificationSlideIn 0.3s ease-out;
}

.code-notification.error {
  background: #dc3545;
}

@keyframes notificationSlideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .code-context-menu {
    min-width: 180px;
    max-width: 250px;
    font-size: 13px;
  }
  
  .context-menu-item {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .context-menu-item-icon {
    margin-right: 10px;
    font-size: 14px;
  }
  
  .context-menu-header {
    padding: 10px 12px;
  }
  
  .context-menu-label {
    padding: 6px 12px 3px 12px;
  }
  
  .context-menu-info {
    padding: 6px 12px;
  }
}

/* Disabled State */
.context-menu-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.context-menu-item:disabled:hover {
  background: transparent;
}

/* Focus States for Accessibility */
.context-menu-item:focus {
  outline: 2px solid #007bff;
  outline-offset: -2px;
}

[data-theme='dark'] .context-menu-item:focus {
  outline-color: #4a90e2;
}

/* Settings Button */
.context-menu-settings {
  border-top: 1px solid #e0e0e0;
  margin-top: 4px;
  padding-top: 8px;
}

[data-theme='dark'] .context-menu-settings {
  border-top-color: #555;
}

.context-menu-settings .context-menu-item-icon {
  color: #6c757d;
}

[data-theme='dark'] .context-menu-settings .context-menu-item-icon {
  color: #adb5bd;
}

.context-menu-settings:hover .context-menu-item-icon {
  color: #007bff;
}

[data-theme='dark'] .context-menu-settings:hover .context-menu-item-icon {
  color: #4a90e2;
}

/* Loading State */
.context-menu-item.loading {
  position: relative;
  color: transparent;
}

.context-menu-item.loading::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Instructions Modal */
.code-instructions-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.code-instructions-modal > div {
  background: white;
  border-radius: 12px;
  padding: 30px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  font-family: Arial, sans-serif;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

[data-theme='dark'] .code-instructions-modal > div {
  background: var(--background-color);
  color: var(--text-color);
}

.code-instructions-modal h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 24px;
}

[data-theme='dark'] .code-instructions-modal h2 {
  color: var(--text-color);
}

.code-instructions-modal kbd {
  background: #f1f3f4;
  border: 1px solid #c1c4c8;
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  color: #333;
  display: inline-block;
  font-family: 'Courier New', monospace;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  padding: 2px 4px;
  white-space: nowrap;
}

[data-theme='dark'] .code-instructions-modal kbd {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.code-instructions-modal code {
  background: #f1f3f4;
  border-radius: 3px;
  color: #d63384;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  padding: 2px 4px;
}

[data-theme='dark'] .code-instructions-modal code {
  background: #2d3748;
  color: #f093fb;
}

.code-instructions-modal .code-preview {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #333;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}

[data-theme='dark'] .code-instructions-modal .code-preview {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.code-instructions-modal .modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.code-instructions-modal .modal-buttons button {
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f8f9fa;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.code-instructions-modal .modal-buttons button:hover {
  background: #e9ecef;
}

.code-instructions-modal .modal-buttons button.primary {
  border: none;
  background: #007bff;
  color: white;
}

.code-instructions-modal .modal-buttons button.primary:hover {
  background: #0056b3;
}

[data-theme='dark'] .code-instructions-modal .modal-buttons button {
  background: #2d3748;
  border-color: #4a5568;
  color: var(--text-color);
}

[data-theme='dark'] .code-instructions-modal .modal-buttons button:hover {
  background: #4a5568;
}

[data-theme='dark'] .code-instructions-modal .modal-buttons button.primary {
  background: #4a90e2;
}

[data-theme='dark'] .code-instructions-modal .modal-buttons button.primary:hover {
  background: #357abd;
}
`, "",{"version":3,"sources":["webpack://./src/components/CodeContextMenu.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Code Context Menu */\n.code-context-menu {\n  background: var(--background-color);\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  max-width: 280px;\n  z-index: 1000;\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 14px;\n  overflow: hidden;\n  animation: contextMenuFadeIn 0.2s ease-out;\n}\n\n[data-theme='dark'] .code-context-menu {\n  background: var(--background-color);\n  border-color: #555;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n@keyframes contextMenuFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Context Menu Header */\n.context-menu-header {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n[data-theme='dark'] .context-menu-header {\n  background: #2d3748;\n  border-bottom-color: #555;\n}\n\n.context-menu-icon {\n  margin-right: 8px;\n  color: #007bff;\n  font-size: 16px;\n}\n\n/* Context Menu Divider */\n.context-menu-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 4px 0;\n}\n\n[data-theme='dark'] .context-menu-divider {\n  background: #555;\n}\n\n/* Context Menu Section */\n.context-menu-section {\n  padding: 4px 0;\n}\n\n.context-menu-label {\n  padding: 8px 16px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n[data-theme='dark'] .context-menu-label {\n  color: #adb5bd;\n}\n\n/* Context Menu Items */\n.context-menu-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  color: var(--text-color);\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n  font-family: inherit;\n}\n\n.context-menu-item:hover {\n  background: #f8f9fa;\n}\n\n[data-theme='dark'] .context-menu-item:hover {\n  background: #2d3748;\n}\n\n.context-menu-item:active {\n  background: #e9ecef;\n}\n\n[data-theme='dark'] .context-menu-item:active {\n  background: #4a5568;\n}\n\n.context-menu-item-icon {\n  margin-right: 12px;\n  font-size: 16px;\n  color: #6c757d;\n  width: 16px;\n  text-align: center;\n}\n\n[data-theme='dark'] .context-menu-item-icon {\n  color: #adb5bd;\n}\n\n/* Specific icon colors */\n.context-menu-item:hover .context-menu-item-icon {\n  color: #007bff;\n}\n\n.context-menu-item[title*=\"R Console\"] .context-menu-item-icon {\n  color: #276dc3;\n}\n\n.context-menu-item[title*=\"RStudio\"] .context-menu-item-icon {\n  color: #75aadb;\n}\n\n.context-menu-item[title*=\"SAS\"] .context-menu-item-icon {\n  color: #e74c3c;\n}\n\n.context-menu-item[title*=\"Copy\"] .context-menu-item-icon {\n  color: #28a745;\n}\n\n.context-menu-item[title*=\"Download\"] .context-menu-item-icon {\n  color: #6c757d;\n}\n\n[data-theme='dark'] .context-menu-item[title*=\"Download\"] .context-menu-item-icon {\n  color: #adb5bd;\n}\n\n/* Context Menu Info */\n.context-menu-info {\n  padding: 8px 16px;\n  color: #6c757d;\n  font-size: 12px;\n  text-align: center;\n  border-top: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n[data-theme='dark'] .context-menu-info {\n  color: #adb5bd;\n  border-top-color: #555;\n  background: #2d3748;\n}\n\n/* Code Block Styling for Right-Click */\n.code-block-interactive {\n  position: relative;\n  cursor: context-menu;\n  user-select: text;\n}\n\n.code-block-interactive:hover {\n  background: rgba(0, 123, 255, 0.05);\n  border-radius: 4px;\n}\n\n[data-theme='dark'] .code-block-interactive:hover {\n  background: rgba(74, 144, 226, 0.1);\n}\n\n.code-block-interactive::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.code-block-interactive:hover::after {\n  box-shadow: inset 0 0 0 1px rgba(0, 123, 255, 0.2);\n}\n\n[data-theme='dark'] .code-block-interactive:hover::after {\n  box-shadow: inset 0 0 0 1px rgba(74, 144, 226, 0.3);\n}\n\n/* Notification Styling */\n.code-notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: #28a745;\n  color: white;\n  padding: 12px 20px;\n  border-radius: 4px;\n  z-index: 10000;\n  font-size: 14px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  animation: notificationSlideIn 0.3s ease-out;\n}\n\n.code-notification.error {\n  background: #dc3545;\n}\n\n@keyframes notificationSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .code-context-menu {\n    min-width: 180px;\n    max-width: 250px;\n    font-size: 13px;\n  }\n  \n  .context-menu-item {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n  \n  .context-menu-item-icon {\n    margin-right: 10px;\n    font-size: 14px;\n  }\n  \n  .context-menu-header {\n    padding: 10px 12px;\n  }\n  \n  .context-menu-label {\n    padding: 6px 12px 3px 12px;\n  }\n  \n  .context-menu-info {\n    padding: 6px 12px;\n  }\n}\n\n/* Disabled State */\n.context-menu-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.context-menu-item:disabled:hover {\n  background: transparent;\n}\n\n/* Focus States for Accessibility */\n.context-menu-item:focus {\n  outline: 2px solid #007bff;\n  outline-offset: -2px;\n}\n\n[data-theme='dark'] .context-menu-item:focus {\n  outline-color: #4a90e2;\n}\n\n/* Settings Button */\n.context-menu-settings {\n  border-top: 1px solid #e0e0e0;\n  margin-top: 4px;\n  padding-top: 8px;\n}\n\n[data-theme='dark'] .context-menu-settings {\n  border-top-color: #555;\n}\n\n.context-menu-settings .context-menu-item-icon {\n  color: #6c757d;\n}\n\n[data-theme='dark'] .context-menu-settings .context-menu-item-icon {\n  color: #adb5bd;\n}\n\n.context-menu-settings:hover .context-menu-item-icon {\n  color: #007bff;\n}\n\n[data-theme='dark'] .context-menu-settings:hover .context-menu-item-icon {\n  color: #4a90e2;\n}\n\n/* Loading State */\n.context-menu-item.loading {\n  position: relative;\n  color: transparent;\n}\n\n.context-menu-item.loading::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 16px;\n  height: 16px;\n  margin: -8px 0 0 -8px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Instructions Modal */\n.code-instructions-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.code-instructions-modal > div {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  font-family: Arial, sans-serif;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n[data-theme='dark'] .code-instructions-modal > div {\n  background: var(--background-color);\n  color: var(--text-color);\n}\n\n.code-instructions-modal h2 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 24px;\n}\n\n[data-theme='dark'] .code-instructions-modal h2 {\n  color: var(--text-color);\n}\n\n.code-instructions-modal kbd {\n  background: #f1f3f4;\n  border: 1px solid #c1c4c8;\n  border-radius: 3px;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);\n  color: #333;\n  display: inline-block;\n  font-family: 'Courier New', monospace;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 1;\n  padding: 2px 4px;\n  white-space: nowrap;\n}\n\n[data-theme='dark'] .code-instructions-modal kbd {\n  background: #2d3748;\n  border-color: #4a5568;\n  color: #e2e8f0;\n}\n\n.code-instructions-modal code {\n  background: #f1f3f4;\n  border-radius: 3px;\n  color: #d63384;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9em;\n  padding: 2px 4px;\n}\n\n[data-theme='dark'] .code-instructions-modal code {\n  background: #2d3748;\n  color: #f093fb;\n}\n\n.code-instructions-modal .code-preview {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  color: #333;\n  white-space: pre-wrap;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n[data-theme='dark'] .code-instructions-modal .code-preview {\n  background: #2d3748;\n  border-color: #4a5568;\n  color: #e2e8f0;\n}\n\n.code-instructions-modal .modal-buttons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.code-instructions-modal .modal-buttons button {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #f8f9fa;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.code-instructions-modal .modal-buttons button:hover {\n  background: #e9ecef;\n}\n\n.code-instructions-modal .modal-buttons button.primary {\n  border: none;\n  background: #007bff;\n  color: white;\n}\n\n.code-instructions-modal .modal-buttons button.primary:hover {\n  background: #0056b3;\n}\n\n[data-theme='dark'] .code-instructions-modal .modal-buttons button {\n  background: #2d3748;\n  border-color: #4a5568;\n  color: var(--text-color);\n}\n\n[data-theme='dark'] .code-instructions-modal .modal-buttons button:hover {\n  background: #4a5568;\n}\n\n[data-theme='dark'] .code-instructions-modal .modal-buttons button.primary {\n  background: #4a90e2;\n}\n\n[data-theme='dark'] .code-instructions-modal .modal-buttons button.primary:hover {\n  background: #357abd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
